<template>
    <div style="width: 100%;height: 100%;">
        <el-row style="height: 7rem;display: flex;align-items: center">
          <el-col :span="24">
              <div class="showSearch" style="margin-left: 2rem" >
                <el-select  :value="xItem" @change="onXItemChange" placeholder="请选择断面" size="small">
                  <el-option
                      v-for="item in opts"
                      :key="item.damcd"
                      :label="item.damnm"
                      :value="item.damcd">
                  </el-option>
                </el-select>
                <el-date-picker
                    size="small"
                    v-model="dateTime"
                    type="date"
                    placeholder="请选择日期"
                    class="searchDate"
                    value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                <el-button type="primary" size="small" class="searchButton" @click="queryData">
                  绘制
                </el-button>
              </div>
          </el-col>
        </el-row>
        <el-row style="height: calc(100% - 7rem);padding: 0 2rem">
          <el-col :span="24" style="height: 100%;">
            <div ref="saturationShow" style="height:100%;width: 100%"></div>
          </el-col>
        </el-row>
    </div>
</template>
<script setup>
  import * as THREE from "../../utils/basejs/three.min";
  import {addGroup, addSaturationLine, addSempsData, addThings, clear,remove} from "./js/saturationthings";
  import { LineMaterial } from "../../utils/basejs/LineMaterial";
  import { OrbitControls } from "../../utils/basejs/OrbitControls";
  import {clearScene} from "../../utils/basejs/addThreeThings";
  import {addTextGroup, removeTextGroup} from "./js/things";
  import {dateTimeToString} from "../../utils/dateUtils";

  let renderer = null;
  let scene = null;
  let camera = null;
  let controls = null;
  let zeroGroup = new THREE.Group();
  let firstGroup = new THREE.Group();
  const lineMat = new LineMaterial({
    // color: 0xb4c8ff,
    color: '#4EABFE',
    linewidth: 3, // in pixels
    dashed: false,
  });
  export default {
    name:'saturation',
    data() {
      return {
        dateTime: null,
        xItem: null,
        opts : [],
        rescd: null,
        coreCoords: [],
        damCoords: [],
        semps:[],
        requestID: null,
        endXY: null,
        fontSize: 1,
        width: 1
      }
    },
    created() {
    },
    mounted() {
      this.threeInit();
      this.initCondition();
    },
    beforeDestroy() {
      if (this.requestID) {
        try {
          // camera.dispose();
          clearScene(scene);
          // scene.background.dispose();
          controls.dispose();
          this.mousePointer = null;
          scene.remove();
          scene.clear();
          scene = null;
          // this.raycaster = null;
          renderer.renderLists.dispose();
          renderer.dispose();
          renderer.forceContextLoss();
          renderer.domElement = null;
          renderer.content = null;
          camera = null;
          renderer = null;
          cancelAnimationFrame(this.requestID);
          THREE.Cache.clear();
          this.timeDiv.removeEventListener("click", this.onMouseClick, true);
          // renderer.forceContextLoss();
          // renderer.content = null;
          // const gl = renderer.domElement.getContext('webgl');
          // gl && gl.getExtension("WEBGL_LOSE_CONTEXT").loseContext();
        }catch (e){
          console.log(e);
        }
      }
      /*if (this.websocket) {
        this.websocket.close();
      }*/
      // this.timeDiv.removeEventListener("click", this.onMouseClick, true);
      window.removeEventListener("resize",this.onWindowResize);
      window.onresize = null;
    },
    methods: {
      animate() {
        this.requestID = requestAnimationFrame(this.animate);
        controls.update();
        // this.render();
        // TWEEN.update();
        // console.log(camera.position);
        lineMat.resolution.set(
            this.timeDiv.offsetWidth,
            this.timeDiv.offsetHeight
        );
        renderer.render(scene, camera);

      },
      threeInit() {
        this.timeDiv = this.$refs.saturationShow;
        camera = new THREE.PerspectiveCamera(
            80,
            this.timeDiv.offsetWidth / this.timeDiv.offsetHeight,
            1,
            12000
        );
        // camera.position.set(0, 30, 0);
        camera.position.set(0,0,50);
        renderer = new THREE.WebGLRenderer({antialias: true});
        renderer.setPixelRatio(window.devicePixelRatio);
        renderer.setSize(
            this.timeDiv.offsetWidth,
            this.timeDiv.offsetHeight
        );
        renderer.antialias=true;
        renderer.alpha=true;
        this.timeDiv.append(renderer.domElement);
        scene = new THREE.Scene();
        scene.background = new THREE.Color('#FFF');
        controls = new OrbitControls(
            camera,
            renderer.domElement
        );
        controls.enableRotate = false;
        controls.autoRotate = false;
        // controls.minDistance = 60;
        // controls.maxDistance = 60;
        controls.enableZoom = false;
        // controls.target0.set(800, 400, 0);
        controls.target.set(0, 0, 0);

        controls.mouseButtons = {
          LEFT: THREE.MOUSE.PAN,
          MIDDLE: THREE.MOUSE.DOLLY,
          RIGHT: THREE.MOUSE.ROTATE,
        };

        // this.requestID = requestAnimationFrame(this.animate);
        // addOverAll(secondGroup);
        // addModel(thirdGroup);
        // this.initBall();
        // this.initModel();
        // window.addEventListener("resize", this.onWindowResize, false);
        // this.timeDiv.addEventListener("mousemove", this.onMouseMove, true);
        // this.timeDiv.addEventListener("click", this.onMouseClick, true);
        // const clock = new THREE.Clock();
        // let time = 0;
        addGroup(scene);
        this.animate();

      },
      initCondition(){
        const now = new Date();
        this.dateTime = dateTimeToString(now,false);
        this.request.get('/rm-bsection/v1/getListForSelect').then(res =>{
          if(res.ok){
            const data = res.data;
            if(data) {
              this.opts = data.items;
              this.rescd = data.rescd;
              if(data.items.length > 0) {
                const item = data.items[0].damcd;
                this.xItem = item;
                this.onXItemChange(item);
              }else {
                this.xItem = null;
              }
            }else {
              this.opts = [];
              this.rescd = '';
              this.xItem = null;
            }
          }else {
            this.$message.error(res.error.message);
          }
        });
      },
      cameraRange(minX,minY,maxX,maxY){
        if(camera.position.x < minX){
          if(camera.position.y < minY) {
            controls.target.set(minX, minY, controls.target.z);
            camera.position.set(minX, minY, camera.position.z);
          }else if(camera.position.y > maxY){
            controls.target.set(minX, maxY, controls.target.z);
            camera.position.set(minX, maxY, camera.position.z);
          }else{
            controls.target.set(minX,controls.target.y,controls.target.z);
            camera.position.set(minX,camera.position.y,camera.position.z);
          }
        }else
        if(camera.position.x > maxX){
          if(camera.position.y < minY) {
            controls.target.set(maxX, minY, controls.target.z);
            camera.position.set(maxX, minY, camera.position.z);
          }else if(camera.position.y > maxY){
            controls.target.set(maxX, maxY, controls.target.z);
            camera.position.set(maxX, maxY, camera.position.z);
          }else{
            controls.target.set(maxX,controls.target.y,controls.target.z);
            camera.position.set(maxX,camera.position.y,camera.position.z);
          }
        }else{
          if(camera.position.y < minY) {
            controls.target.set(controls.target.x, minY, controls.target.z);
            camera.position.set(camera.position.x, minY, camera.position.z);
          }else if(camera.position.y > maxY){
            controls.target.set(controls.target.x,maxY, controls.target.z);
            camera.position.set(camera.position.x, maxY, camera.position.z);
          }else{
            controls.saveState();
          }
        }
      },
      onXItemChange(val){
        this.xItem = val;
        const params = {damcd: val,rescd: this.rescd};
        clear('saturationLine');
        this.request.post('/rm-bsection/v1/getSectionMap',params).then(res =>{
            if(res.ok){
              const data = res.data;
              this.semps = data.rmBSempVOS;
              this.coreCoords = data.coreCoords;
              this.damCoords = data.damCoords;
              this.endXY = data.endXY;
              const target = data.target;
              const back = data.backfillCoords;
              if(target){
                const x = parseFloat(target.x);
                const y = parseFloat(target.y);
                const z = parseFloat(target.z);
                camera.position.set(x,y,z);
                controls.target.set(x,y,0);
              }

              const fontSize = parseFloat(data.size);
              this.fontSize = fontSize;
              const width = parseFloat(data.width);
              this.width = width;
              addThings(data.coreCoords,data.damCoords,data.rmBSempVOS,back,fontSize,width);
              remove('sempData')
            }else {
              this.$message.error(res.error.message);
            }
        });
      },
      queryData(){
        if(this.xItem === undefined || this.xItem === null){
          this.$message.warning('请先选择断面信息！');
          return;
        }
        if(!this.dateTime){
          this.$message.warning('请先输入时间！');
          return;
        }
        remove('saturationLine');
        const params = {dt: this.dateTime,damCoords: this.damCoords,coreCoords: this.coreCoords,rmBSempS: this.semps,endXY: this.endXY};
        // const params = {xMpcd: this.xMpcd,mstmGE: this.dateTime[0],mstmLE: this.dateTime[1]};
        this.request.post('/rm-bsection/v1/getSaturation',params).then(res =>{
          if(res.ok){
            const data = res.data;
            const lines = data.lines;
            const pzwls = data.pzwls;
            console.log(data)
            if(lines.length > 2){
              addSaturationLine(lineMat,lines,this.fontSize);
              addSempsData(pzwls,this.fontSize,this.width);
            }else{
              this.$message.warning('数据量太少，无法绘制！');
            }
          }else {
            this.$message.error(res.error.message);
          }
        });
      },
    },
    watch: {
      "$store.state.head.skCd"() {
        const object = scene.getObjectByName('saturationGroup');
        if(object) {
          clearScene(object);
        }
        this.initCondition();
      }
    }
}
</script>
<style scoped>
  .el-row{
    width: 100%;
  }
  .showSearch{
    display: flex;
    flex-direction: row;
  }
  .searhInput{
    width: 20rem;
    margin-left: 1.5rem;
  }
  .searchDate{
    width: 20rem;
    margin-left: 1.5rem;
  }
  .searchButton{
    margin-left: 1.5rem;
  }
  .showData{
    height: 100%;
    width: 100%;
    padding-left: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .activeButton{
    background-color: #409EFF;
    border-color: #409EFF;
    width: 9.2rem;
  }
  .normalButton{
    background-color: #ecf5ff;
    border-color: #b3d8ff;
    color: #409eff;
    width: 9.2rem;
  }
  .pageStyle{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .tableDiv{
    width: calc(100% - 2rem);
    height: 100%;
  }
  .chartStyle{
    width: 98%;
    height: 100%;
  }
</style>
